import React from 'react';
import styled, { css } from 'styled-components';
import { FaQuestionCircle } from 'react-icons/fa';

import themeVars, { fromProps, ifProp, ifPropEquals } from '+/utils/themeVars';

import PropTypes from '../instances/propTypesInstance';

export const StyledQuestionIcon = styled(FaQuestionCircle)`
  margin: -3px 0 0 5px;
  vertical-align: middle;
`;

const TooltipContainer = styled.div`
  height: 0;
  position: absolute;
  top: 100%;
  ${ifPropEquals(
    'direction',
    'left',
    css`
      left: ${ifProp({ center: '20%', default: '-.3rem' })};
    `,
    css`
      right: ${ifProp({ center: '20%', default: '-.3rem' })};
    `,
  )};
  transform: translateY(0);
  visibility: hidden;
  width: 0;
  z-index: ${themeVars('tooltipZIndex')};

  background: ${themeVars('tooltipColor')};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.4);
  opacity: 0;

  color: ${themeVars('colorWhite')};
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.4;

  ${fromProps('hoverable')}:hover & {
    height: auto;
    padding: 1.5em;
    visibility: visible;
    width: auto;
    opacity: 0.9;
    transform: translateY(0.3rem);
    transition: transform 0.2s ease-out, opacity 0.2s ease-out;
  }

  &::before {
    height: 10px;
    position: absolute;
    ${ifPropEquals(
    'direction',
    'left',
    css`
        left: 8px;
      `,
    css`
        right: 8px;
      `,
  )};
    top: -5px;
    transform: rotate(45deg);
    visibility: visible;
    width: 10px;

    background: ${themeVars('tooltipColor')};
    border: 2px solid ${themeVars('tooltipBorderColor')};
    border-bottom-color: ${themeVars('tooltipColor')};
    border-right-color: ${themeVars('tooltipColor')};

    content: '';
  }
`;

const TooltipText = styled.div`
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  visibility: visible;
  width: ${p => p.width || '12rem'};
`;

const StyledTooltip = ({ text, hoverable, center = false, direction = 'right', width = null }) => (
  <TooltipContainer hoverable={hoverable} center={center} direction={direction}>
    <TooltipText width={width}>{text}</TooltipText>
  </TooltipContainer>
);

StyledTooltip.propTypes = {
  text: PropTypes.node.isRequired,
  hoverable: PropTypes.shape({ render: PropTypes.func }).isRequired,
  center: PropTypes.bool,
  direction: PropTypes.string,
  width: PropTypes.string,
};

export default StyledTooltip;
